"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.COMPLETED = exports.CONFIRMED = exports.MEDIATION = exports.CANCELED = exports.CREATED = void 0;
exports.CREATED = {
    ERROR: {
        code: 'OPERATIONS.TRANSITIONS_CREATED_ERROR',
        message: 'Operation fixed and canceled by Airtm support',
    },
};
exports.CANCELED = {
    TIMER_UNACCEPTED: {
        code: 'OPERATIONS.TRANSITIONS_CANCELED_TIMER_UNACCEPTED',
        message: '',
    },
    TIMER_ACCEPTED: {
        code: 'OPERATIONS.TRANSITIONS_CANCELED_TIMER_ACCEPTED',
        message: '',
    },
    ADMIN: {
        code: 'OPERATIONS.TRANSITIONS_CANCELED_ADMIN',
        message: '',
    },
    ERROR: {
        code: 'OPERATIONS.TRANSITIONS_CANCELED_ERROR',
        message: 'Operation fixed and canceled by Airtm support',
    },
};
exports.MEDIATION = {
    SENDER: {
        code: 'OPERATIONS.TRANSITIONS_MEDIATION_SENDER',
        message: '',
    },
    ADMIN: {
        code: 'OPERATIONS.TRANSITIONS_MEDIATION_ADMIN',
        message: '',
    },
    TIMER: {
        code: 'OPERATIONS.TRANSITIONS_MEDIATION_TIMER',
        message: '',
    },
    FLAGGED_OPERATION: {
        code: 'OPERATIONS.TRANSITIONS_MEDIATION_FLAGGED_OPERATION',
        message: '',
    },
    FLAGGED_USER: {
        code: 'OPERATIONS.TRANSITIONS_MEDIATION_FLAGGED_USER',
        message: '',
    },
};
exports.CONFIRMED = {
    ADMIN: {
        code: 'OPERATIONS.TRANSITIONS_CONFIRMED_ADMIN',
        message: '',
    },
    ERROR: {
        code: 'OPERATIONS.TRANSITIONS_CONFIRMED_ERROR',
        message: 'Operation fixed and confirmed by Airtm support',
    },
};
exports.COMPLETED = {
    ADMIN: {
        code: 'OPERATIONS.TRANSITIONS_COMPLETED_ADMIN',
        message: '',
    },
    ERROR: {
        code: 'OPERATIONS.TRANSITIONS_COMPLETED_ERROR',
        message: 'Operation fixed and completed by Airtm support',
    },
};
